export default "__VITE_ASSET__2253e125__"